import { CargoHoldFloor } from '@/models/CargoHoldFloor'
import CachedResourceStore from '@/store/modules/CachedResourceStore'

export default new CachedResourceStore<CargoHoldFloor>(CargoHoldFloor, {
	namespaced: true
})
